import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import ConstraintService from "../service/constraintService";

const useConstraintData = () => {
  const dispatch = useAppDispatch();
  const interceptorIsReady = useAppSelector(
    (state) => state.apiConfigurationState.interceptorIsReady,
  );

  // Guard against firing before the auth interceptor is configured — on page refresh the token
  // refresh is async, so requests sent before interceptorIsReady would go out unauthenticated.
  // Fetch all three in parallel so data is ready regardless of which tab the user opens first.
  useEffect(() => {
    if (!interceptorIsReady) return;
    ConstraintService.getCategories(dispatch).catch(() => {});
    ConstraintService.getClients(dispatch).catch(() => {});
    ConstraintService.getEmployees(dispatch).catch(() => {});
  }, [dispatch, interceptorIsReady]);
};

export default useConstraintData;
